import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../../../Building'
import { REQUEST_FORM_FIELD_NAME_APPLICANT } from '../../RequestForm.constants'

export function getBuildingApiParams(values, isStaff) {
  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    inhabitant: isStaff
      ? null
      : values[REQUEST_FORM_FIELD_NAME_APPLICANT]?.value,
    is_promo: false,
  }
}
